import firecrackerLogo from 'img/logo_firecracker-cropped.svg'
import instaIcon from 'img/insta-icon.svg'
import linkedinIcon from 'img/linkedin-icon.svg'
import 'css/components/footer.css'

export const Footer = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<img src={firecrackerLogo} alt="Footer Logo" className="footer-logo" />
				<div className="footer-right">
					<div className="social-links">
						<a href="https://www.instagram.com/allforonelearn/" target="_blank" rel="noopener noreferrer"><img src={instaIcon} alt="Instagram" /></a>
						<a href="https://www.linkedin.com/company/all-for-one-afo/posts/?feedView=all" target="_blank" rel="noopener noreferrer"><img src={linkedinIcon} alt="LinkedIn" /></a>
					</div>
					<p className="footer-text">
						Questions? Email <a href="mailto:hey@allforonelearn.com" className="footer-email">hey@allforonelearn.com</a>
					</p>
				</div>
			</div>
		</footer>
	)
}


export const StudentFooter = () => {
	return (
		<footer className="footer">
			<div className="footer-container">
				<img src={firecrackerLogo} alt="Footer Logo" className="footer-logo" />
				<div className="footer-right">
					<p className="footer-text footer-copyright">Copyright © {new Date().getFullYear()} All For One.</p>
				</div>
			</div>
		</footer>
	)
}


export const FooterBottom = () => {
	return (
		<section className="footer-bottom">
			<div className="footer-bottom-container">
				<p>Copyright © {new Date().getFullYear()} All For One. <a href="privacy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a></p>
			</div>
		</section>
	)
}
